/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestLiquityTroveManager extends Contract<ITestLiquityTroveManager> {
  getBorrowingFee: Send<(_LUSDDebt: BigNumberish) => BigNumber, ITestLiquityTroveManager>
  'getBorrowingFee(uint256)': Send<(_LUSDDebt: BigNumberish) => BigNumber, ITestLiquityTroveManager>
}

let ITestLiquityTroveManagerBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestLiquityTroveManagerBytecode = '0x';
}

// prettier-ignore
export const ITestLiquityTroveManager = contract<ITestLiquityTroveManager>(ITestLiquityTroveManagerBytecode)`
  function getBorrowingFee(uint256 _LUSDDebt) returns (uint256 fee_)
`;